import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  border-radius: 10px;
  z-index: 4;
  right: 0;
  top: 0;
  margin: 30px;
  padding: 5px;
  overflow: hidden;
`;
